<template>
  <div class="modal_overlay" @click.self="closeModal">
    <div class="modal_pop_small">
      <div class="smallPop popup_block_large">
        <div class="pop_title mt-10">
          <p>
            {{ props.status == 1 ? "전체 유저 리스트" : "금일 가입한 유저 리스트" }}
          </p>
        </div>
        <div class="con_wrap">
          <div class="table-responsive text-nowrap dataTables_wrapper">
            <table class="table">
              <thead class="table-light">
                <tr>
                  <th>EX_IDX</th>
                  <th>UID</th>
                  <th>거래소</th>
                  <th>날짜</th>
                  <th>연동상태</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="memberList.length == 0">
                  <td colspan="7">데이터 내역이 없습니다.</td>
                </tr>
                <tr v-for="(data, i) in memberList" :key="i">
                  <td>{{ data.retri_id }}</td>
                  <td>{{ data.uid }}</td>
                  <td>{{ getExchangeLabel(data.exchange) }}</td>
                  <td>{{ data.datetime }}</td>
                  <td>{{ data.connet == 1 ? '승인 대기 중' : '승인 완료' }}</td>
                </tr>
              </tbody>
            </table>
            <ThePaging
              v-if="totalPages > 1"
              :page="page"
              :changePage="changePage"
              :totalPages="totalPages"
            />
          </div>
        </div>
        <div class="btn_bottom">
          <button class="btn_gray" @click="closeModal">확인</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useStore } from "vuex";
import ThePaging from "@/components/public/ThePaging.vue";
import { computed } from "vue";
import { getExchangeLabel } from "@/utils/exchangeList";
const store = useStore();
const props = defineProps({
  status: { type: Number },
});
const page = computed(() => {
  return store.state.manage.page;
});
const totalPages = computed(() => {
  return store.state.manage.totalPages;
});
const memberList = computed(() => {
  return store.state.manage.memberList;
});
const closeModal = () => {
  store.commit("admin/changeModalState", false);
};

const createdFn = () => {
  store.commit("manage/setPage", 1);
  props.status == 1
    ? store.dispatch("manage/getTotalMember")
    : store.dispatch("manage/getNewMember");
};
const changePage = async (str) => {
  store.commit("manage/setPage", str);
  props.status == 1
    ? await store.dispatch("manage/getTotalMember")
    : await store.dispatch("manage/getNewMember");
};
createdFn();
</script>

<style lang="scss" scoped></style>
